<script setup>
import { loadPageWithLoader } from "@/utils/webpack-helper";
import { useCheckoutProStore } from "@/store/checkout-pro";
import { useContextStore } from "@/store/context";

definePageMeta({
  layout: "commander-pro",
  middleware: "authenticated"
});

const { layout } = storeToRefs(useContextStore());
const { checkout } = storeToRefs(useCheckoutProStore());
const { create: createCheckout, setStepValue } = useCheckoutProStore();

const component = computed(() => {
  return loadPageWithLoader(
    lazyComponents[`/components/pages/commander-pro/${layout.value}.vue`]
  );
});

onMounted(async () => {
  setStepValue(1);
  if (!checkout.value) {
    await createCheckout();
  }
});
</script>

<template>
  <component :is="component" />
</template>
